import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Counter, Filter, Delay, Parallel, Reward, Sequential } from 'src/app/api/api-campaigns.service.generated';
import { FilterStrategyEditComponent } from '../filter-strategy-edit/filter-strategy-edit.component';
import { ParallelStrategyEditComponent } from '../parallel-strategy-edit/parallel-strategy-edit.component';
import { RewardStrategyEditComponent } from '../reward-strategy-edit/reward-strategy-edit.component';
import { SequentialStrategyEditComponent } from '../sequential-strategy-edit/sequential-strategy-edit.component';
import { CounterStrategyEditComponent } from '../counter-strategy-edit/counter-strategy-edit.component';
import { DelayStrategyEditComponent } from '../delay-strategy-edit/delay-strategy-edit.component';

@Component({
  selector: 'app-strategy-edit',
  templateUrl: './strategy-edit.component.html',
  styleUrls: ['./strategy-edit.component.scss'],
  imports: [
    FilterStrategyEditComponent,
    ParallelStrategyEditComponent,
    RewardStrategyEditComponent,
    SequentialStrategyEditComponent,
    CounterStrategyEditComponent,
    DelayStrategyEditComponent
  ]
})
export class StrategyEditComponent implements OnInit, OnChanges {


  @Input() strategy: any
  @Output() strategyChange = new EventEmitter<any>();   // 2 way binding propName + Change

  filter: Filter;
  parallel: Parallel;
  sequential: Sequential;
  reward: Reward;
  delay: Delay;
  counter: Counter;

  constructor() { }


  ngOnChanges(changes: SimpleChanges): void {
    const strategyChange = changes.strategy && (changes.strategy.previousValue != changes.strategy.currentValue);
    if (strategyChange)
      this.setStrategy(this.strategy);
  }


  setStrategy(strategy: any) {
    if (!strategy) return;

    this.clearAll();

    switch (strategy.name) {
      case StrategyName.Filter:
        this.filter = strategy as Filter;
        break;
      case StrategyName.Reward:
        this.reward = strategy as Reward;
        break;
      case StrategyName.Parallel:
        this.parallel = strategy as Parallel;
        break;
      case StrategyName.Sequential:
        this.sequential = strategy as Sequential;
        break;
      case StrategyName.Delay:
        this.delay = strategy as Delay;
        break;
      case StrategyName.Counter:
        this.counter = strategy as Counter;
        break;
      default:
        break;
    }
  }

  clearAll() {
    this.filter = undefined;
    this.parallel = undefined;
    this.sequential = undefined;
    this.reward = undefined;
    this.delay = undefined;
    this.counter = undefined;
  }

  ngOnInit() { }

}

export enum StrategyName {
  Filter = 'Filter',
  Reward = 'Reward',
  Parallel = 'Parallel',
  Sequential = 'Sequential',
  Delay = 'Delay',
  Counter = 'Counter'
}
